module.exports = __webpack_public_path__ + "img/ooh_white.e49943f5.png";